var r = function r(_ref) {
    var a = _ref.action,
      n = _ref.category,
      t = _ref.label,
      e = _ref.value;
    window.dataLayer = window.dataLayer || [], function () {
      window.dataLayer.push(arguments);
    }("event", a, {
      event_category: n,
      event_label: t,
      value: e
    });
  },
  l = {
    main: "NavigationMain",
    mashboard: "NavigationMainMashboard",
    search: "NavigationMainSearch",
    resources: "NavigationMainAllResources",
    help: "NavigationMainAllResourcesHelp",
    account: "NavigationMainAccount",
    product: "NavigationMainProduct",
    guides: "NavigationMainAllResourcesGuides"
  },
  d = function d(_ref2) {
    var a = _ref2.isLoggedIn;
    return function (_ref3) {
      var n = _ref3.action,
        t = _ref3.category,
        _ref3$label = _ref3.label,
        e = _ref3$label === void 0 ? "click" : _ref3$label,
        _ref3$disregardLogin = _ref3.disregardLogin,
        o = _ref3$disregardLogin === void 0 ? !1 : _ref3$disregardLogin;
      var i = o ? "All" : a ? "LoggedIn" : "LoggedOut",
        c = "".concat(l[t]).concat(i),
        s = "".concat(c, ":").concat(n),
        g = "".concat(s, ":").concat(e);
      r({
        action: s,
        category: c,
        label: g
      });
    };
  };
export { d as initEventHandler, r as sendGAEvent };